const BASE = process.env.PUBLIC_URL || "";

console.log("base from approutes", BASE);

const APP_ROUTES = {
  LOGINFORM: `${BASE}/`,
  FORGETPASSWORD: `${BASE}/forgot-password`,
  DASHBOARD: `${BASE}/dashboard`,
  APPOINTMENTS: `${BASE}/appointments`,
  PAYMENTS: `${BASE}/payments`,
  PATIENTS: `${BASE}/patients`,
  BILLINGREPORTS: `${BASE}/billing-repors`,
  VIDEOCALL: `${BASE}/videocall`,
  SETTINGS: `${BASE}/settings`,
  CONSULTATIONNOTES: `${BASE}/consultaion_notes`,
  EPRESCRIPTION: `${BASE}/eprescription`,
  VCPAGE: `${BASE}/vcpage`,
  CHAT: `${BASE}/chat`,
  MEDICALRECORDS: `${BASE}/medicalrecords`,
  VIEWMEDICALRECORDS: `${BASE}/viewmedicalrecords`,
  ORDERREPORT: `${BASE}/order_report`,
  AUTHENTICATE: `${BASE}/authenticate`,
  MOBILELOGIN: `${BASE}/mobile-login`,
  NEWCONSUL: `${BASE}/new-consult`,
  HEALTHSUMMARY: `${BASE}/healthsummary`,
  NOTIFICATION: `${BASE}/notification`,
  REFERTO: `${BASE}/referTo`,
  SLOT: `${BASE}/slot`,
  VIDEO: `${BASE}/video`,
  VIDEOCONSULT: `${BASE}/consult`,
  NEWDASHBOARD: `${BASE}/newdashboard`,
  MAPPEDCLINICS: `${BASE}/mappedclinics`,
  APPTCALENDAR: `${BASE}/calendar-view`,
  FAVMEDICINE: `${BASE}/fav-medicine`,
  RPMPATIENTPALLETTE: `${BASE}/patient-pallette`,
  PATIENTMONITORING: `${BASE}/patient-monitoring`,
  RPMDASHBOARD: `${BASE}/rpm-dashboard`,
  RPMMEDICALHISTORY: `${BASE}/rpm-medicalhistory`,

  //Direct Links
  SHARECALL: `${BASE}/vc/:id/:type`,
  SHAREPAYMENTS: `${BASE}/s/v1`,
  DIRECTLINK: `${BASE}/v1/`,
  MEDPHARMA: `${BASE}/sp/v1/p`,
  LABPHARMA: `${BASE}/sp/v1/l`,
  SHAREPRESCRIPTION: `${BASE}/prescription/:id`,
  EMERGENCYQR: `${BASE}/emergencyqr/:id`,
  DIRECTJOINCALL: `${BASE}/vc`,
  RPMVITALPARAMS: `${BASE}/vitalparams`,
  RPMTASKFREQUENCY: `${BASE}/taskfrequency`,
  DEVICESETUP: `${BASE}/devicesetup`,
  RPMACTIVITYREPORT: `${BASE}/activity-report`,
  RPMCLINICALNOTES: `${BASE}/rpmclinicalnotes`,

  //Payment
  PHONEPEPAYMENT: `${BASE}/phonepepayment/:transactionId`,
  RPMMEDICALRECORDS: `${BASE}/medicalrecords`,

  PATIENTLIST: `${BASE}/patientlist`,
  PATIENTCRITICAL: `${BASE}/patient-critical`,
  PATIENTABNORMAL: `${BASE}/patient-abnormal`,
  PATIENTNORMAL: `${BASE}/patient-normal`,
};

export { APP_ROUTES };
